import { useLanguage } from "@/lib/i18n";
import "./LanguageToggle.css";

const LanguageToggle = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div className="lang-toggle" data-testid="language-toggle" role="group" aria-label="Reading language">
      <button
        type="button"
        className={`lang-opt${lang === "english" ? " is-active" : ""}`}
        data-testid="lang-english"
        aria-pressed={lang === "english"}
        onClick={() => setLang("english")}
      >
        English
      </button>
      <span className="lang-sep" aria-hidden="true">
        |
      </span>
      <button
        type="button"
        className={`lang-opt${lang === "hinglish" ? " is-active" : ""}`}
        data-testid="lang-hinglish"
        aria-pressed={lang === "hinglish"}
        onClick={() => setLang("hinglish")}
      >
        Hinglish
      </button>
    </div>
  );
};

export default LanguageToggle;
